<div fxLayout="column" fxLayoutAlign="start space-between" class="w-100 h-100">
    @if (form) {
        <form [formGroup]="form" (submit)="submit()" fxLayout="column" fxLayoutAlign="start space-between"
              class="w-100 h-100 pt-40 pl-24 pr-24 pb-24 dialog-container">
            <div class="w-100 h-100 overflow-y hide-scroll-bar pb-28" fxLayout="column" fxLayoutAlign="start start">
                <div class="t1-semi-bold">{{ 'i18n_af_dialogTitleFilters' | translate }}</div>
                <div class="h-fit-content w-100" fxLayout="column" fxLayoutAlign="start stretch">
                    @for (field of dialogData.fields; track field) {
                        @if (form.controls[field.name]) {
                            <mat-expansion-panel
                                class="filter mt-24 w-100"
                                [hideToggle]="Spinner.isShown(field.name)"
                                [disabled]="Spinner.isShown(field.name)">
                                <mat-expansion-panel-header [class.loading]="Spinner.isShown(field.name)"
                                                            class="w-100"
                                                            fxLayout="start space-between">
                                    @if (!selectedValueCount(field)) {
                                        <mat-panel-title fxFlex class="no-wrap">
                                            <span class="truncate">
                                                @if (field.translationPrefix) {
                                                    {{ 'i18n_af_filterDialogField#' + field.translationPrefix + '#' + field.name | translate }}
                                                } @else {
                                                    {{ 'i18n_af_filterDialogField#' + field.name | translate }}
                                                }
                                                @if (field.type === 'dateRange' && field.name !== 'dateRange' && field.name !== 'deletedDateRange') {
                                                    @if ($any(form.controls)[field.name]?.value; as v) {
                                                        <span class="c-primary-green-800 ml-8">
                                                        @if (v.startDate?.date || v.startDate?.time) {
                                                            {{ 'i18n_af_labelFrom'| translate }} {{ v.startDate?.date | date: 'dd.MM.yyyy' }} {{ v.startDate?.time }}
                                                        }
                                                            @if (v.endDate?.date || v.endDate?.time) {
                                                                {{ 'i18n_af_labelTo'| translate }}  {{ v.endDate?.date | date: 'dd.MM.yyyy' }} {{ v.endDate?.time }}
                                                            }
                                                    </span>
                                                    }
                                                }
                                                @if (field.name === 'amountRange') {
                                                    @if (form?.controls?.amountRange?.value; as a) {
                                                        <span class="c-primary-green-800 ml-8">
                                                        @if (a.from !== null && a.from !== undefined) {
                                                            {{ 'i18n_af_labelFrom' | translate }}
                                                            {{ isEditedAmount() ? (a.from | tiynTenge | numberTriplesFormat) : (a.from | numberTriplesFormat) }}
                                                        }
                                                            @if (a.to !== null && a.to !== undefined) {
                                                                {{ 'i18n_af_labelTo' | translate }}
                                                                {{ isEditedAmount() ? (a.to | tiynTenge | numberTriplesFormat) : (a.to | numberTriplesFormat) }}
                                                            }
                                                            @if (a.currency) {
                                                                {{ getCurrencyDisplay(a.currency) }}
                                                            }
                                                    </span>
                                                    }
                                                }
                                                @if (field.name === 'accountBalanceRange') {
                                                    @if (form?.controls?.accountBalanceRange?.value; as b) {
                                                        <span class="c-primary-green-800 ml-8">
                                                       @if (b.from !== null && b.from !== undefined) {
                                                           {{ 'i18n_af_labelFrom' | translate }}
                                                           {{ isEditedBalance() ? (b.from | tiynTenge | numberTriplesFormat) : (b.from | numberTriplesFormat) }}
                                                       }
                                                            @if (b.to !== null && b.to !== undefined) {
                                                                {{ 'i18n_af_labelTo' | translate }}
                                                                {{ isEditedBalance() ? (b.to | tiynTenge | numberTriplesFormat) : (b.to | numberTriplesFormat) }}
                                                            }
                                                            @if (b.currency) {
                                                                {{ getCurrencyDisplay(b.currency) }}
                                                            }
                                                      </span>
                                                    }
                                                }
                                                @if (field.type === 'date') {
                                                    @if ($any(form.controls)[field.name]?.value?.date; as date) {
                                                        <span class="c-primary-green-800 ml-8">{{ date | date: 'dd.MM.yyyy' }}</span>
                                                    }
                                                }
                                                @if (field.type === 'text') {
                                                    <span class="c-primary-green-800 ml-8">
                                                        {{ form.get(field.name).value }}
                                                    </span>
                                                }
                                                    </span>
                                        </mat-panel-title>
                                    }
                                    @if (selectedValueCount(field) > 0) {
                                        <mat-panel-title
                                            fxFlex
                                            class="no-wrap"
                                            [innerHtml]="getSelectedFieldTranslation(field) | translate: {
                                                count: selectedValueCount(field),
                                                class: 'c-primary-green-800 ml-4'
                                            }">
                                        </mat-panel-title>
                                    }
                                    @if (Spinner.isShown(field.name)) {
                                        <mat-panel-description fxLayoutAlign="end">
                                            <ui-kit-spinner [diameter]="16" [strokeWidth]="3" [spinnerIds]="field.name"/>
                                        </mat-panel-description>
                                    }
                                </mat-expansion-panel-header>
                                @if (filterSelectField(field); as field) {
                                    <div [formGroupName]="field.name" fxLayout="column" fxLayoutAlign="start stretch"
                                         class="w-100 h-100 filter-container">
                                        @if (fieldOriginalValueHolder[field.name]?.length > SEARCHABLE_FIELD_VALUES_LENGTH) {
                                            <mat-form-field
                                                class="w-100"
                                                fxFlex>
                                                <input [placeholder]="'i18n_af_placeholderSearch' | translate" matInput type="text"
                                                       [formControl]="searchControls[field.name]"/>
                                                <ui-kit-svg matPrefix matRipple class="i-16 circle p-8 ml-8 c-primary-gray-600"
                                                            name="ic_search"/>
                                                <ui-kit-svg matSuffix matRipple
                                                            class="i-16 circle pointer p-8 ml-8 mr-8 c-primary-gray-600"
                                                            name="ic_cross"
                                                            (click)="clearSearchValue(field)"/>
                                            </mat-form-field>
                                        }
                                        <div fxLayout="column" fxLayoutAlign="start"
                                             class="w-100 h-100 filter-items-container"
                                             [class.mt-24]="fieldOriginalValueHolder[field.name]?.length > SEARCHABLE_FIELD_VALUES_LENGTH">
                                            @for (value of field.values; track value) {
                                                <div>
                                                    <ui-kit-checkbox appearance="small"
                                                                     [formControlName]="$any(value)?.code || value"
                                                                     (change)="!field.isMultiSelect && checkboxChecked(field, $any(value)?.code || value, $event.source)">
                                                        {{ $any(value).name_ru || ('i18n_af_filter_field_' + field.name + '#' + value) | translate }}
                                                    </ui-kit-checkbox>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                }
                                @if (field.type === 'dateRange') {
                                    @if ((field.name === 'dateRange' || field.name === 'deletedDateRange') && form.controls[field.name]) {
                                        <af-date-range-picker-field
                                            class="w-100"
                                            fxFlex
                                            iconPosition="left"
                                            [shouldValidateRange]="true"
                                            [form]="form.controls[field.name]"/>
                                    } @else if (form.controls[field.name]) {
                                        <div
                                            [formGroupName]="field.name" fxLayout="column" fxLayoutAlign="start stretch"
                                            fxLayoutGap="16"
                                            class="w-100">
                                            @if ($any(form.controls)[field.name]?.controls?.startDate) {
                                                <af-date-picker-field
                                                    labelTranslationKey="i18n_af_labelDateTimeFrom"
                                                    placeholderTranslationKey="i18n_af_placeholderDateTimeFrom"
                                                    displayFormat="DD.MM.YYYY HH:MM"
                                                    iconPosition="left"
                                                    [form]="$any(form.controls)[field.name].controls.startDate"
                                                    [showPickerActions]="true"
                                                    [supportedDateFormat]="['DDMMYYYYHHMM', 'DD.MM.YYYY HH:MM']"
                                                    [dateFormats]="DATE_TIME_FORMATS"/>
                                            }
                                            @if ($any(form.controls)[field.name]?.controls?.endDate) {
                                                <af-date-picker-field
                                                    labelTranslationKey="i18n_af_labelDateTimeTo"
                                                    placeholderTranslationKey="i18n_af_placeholderDateTimeTo"
                                                    displayFormat="DD.MM.YYYY HH:MM"
                                                    iconPosition="left"
                                                    [form]="$any(form.controls)[field.name].controls.endDate"
                                                    [showPickerActions]="true"
                                                    [isEndDate]="true"
                                                    [supportedDateFormat]="['DDMMYYYYHHMM', 'DD.MM.YYYY HH:MM']"
                                                    [dateFormats]="DATE_TIME_FORMATS"/>
                                            }
                                        </div>
                                    }
                                }
                                @if (field.type === 'date' && form.controls[field.name]) {
                                    <af-date-picker-field
                                        iconPosition="left"
                                        displayFormat="DD.MM.YYYY"
                                        [form]="$any(form.controls)[field.name]"
                                        [showPickerActions]="false"
                                        [supportedDateFormat]="['DDMMYYYY', 'DD.MM.YYYY']"
                                        [dateFormats]="DATE_FORMATS"/>
                                }
                                @if (field.type === 'amountRange') {
                                    <div class="w-100" formGroupName="amountRange" fxLayout="column"
                                         fxLayoutAlign="start start">
                                        <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelAmountFrom' | translate }}</div>
                                        <mat-form-field class="mt-4 w-100">
                                            <input matInput
                                                   type="text"
                                                   mask="separator.2"
                                                   name="from"
                                                   [leadZero]="true"
                                                   [placeholder]="'i18n_af_placeholderEnterAmount' | translate"
                                                   [outputTransformFn]="removeDotTransform"
                                                   [allowNegativeNumbers]="false"
                                                   [formControl]="form.controls.amountRange.controls.from"/>
                                        </mat-form-field>
                                        <div class="t5 c-primary-gray-600 mt-16">{{ 'i18n_af_labelAmountTo' | translate }}</div>
                                        <mat-form-field class="mt-4 w-100">
                                            <input matInput
                                                   type="text"
                                                   name="from"
                                                   mask="separator.2"
                                                   [leadZero]="true"
                                                   [placeholder]="'i18n_af_placeholderEnterAmount' | translate"
                                                   [outputTransformFn]="removeDotTransform"
                                                   [allowNegativeNumbers]="false"
                                                   [formControl]="form.controls.amountRange.controls.to"/>
                                        </mat-form-field>
                                        <div class="mt-16 w-100">
                                            <af-dictionary-selector
                                                dictionaryName="currency"
                                                [control]="form.controls.amountRange.controls.currency"
                                                [predefinedValue]="form.controls.amountRange.controls.currency.value"
                                                label="i18n_af_labelCurrency"
                                                placeholder="i18n_af_placeholderCurrency">
                                            </af-dictionary-selector>
                                        </div>
                                    </div>
                                }
                                @if (field.type === 'accountBalanceRange') {
                                    <div class="w-100" formGroupName="accountBalanceRange" fxLayout="column"
                                         fxLayoutAlign="start start">
                                        <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelAmountFrom' | translate }}</div>
                                        <mat-form-field class="mt-4 w-100">
                                            <input matInput
                                                   type="text"
                                                   mask="separator.2"
                                                   name="from"
                                                   [leadZero]="true"
                                                   [placeholder]="'i18n_af_placeholderEnterAmount' | translate"
                                                   [outputTransformFn]="removeDotTransform"
                                                   [allowNegativeNumbers]="false"
                                                   [formControl]="form.controls.accountBalanceRange.controls.from"/>
                                        </mat-form-field>
                                        <div class="t5 c-primary-gray-600 mt-16">{{ 'i18n_af_labelAmountTo' | translate }}</div>
                                        <mat-form-field class="mt-4 w-100">
                                            <input matInput
                                                   type="text"
                                                   name="from"
                                                   mask="separator.2"
                                                   [leadZero]="true"
                                                   [placeholder]="'i18n_af_placeholderEnterAmount' | translate"
                                                   [outputTransformFn]="removeDotTransform"
                                                   [allowNegativeNumbers]="false"
                                                   [formControl]="form.controls.accountBalanceRange.controls.to"/>
                                        </mat-form-field>
                                        <div class="mt-16 w-100">
                                            <af-dictionary-selector
                                                dictionaryName="currency"
                                                [control]="form.controls.accountBalanceRange.controls.currency"
                                                [predefinedValue]="form.controls.accountBalanceRange.controls.currency.value"
                                                label="i18n_af_labelCurrency"
                                                placeholder="i18n_af_placeholderCurrency">
                                            </af-dictionary-selector>
                                        </div>
                                    </div>
                                }
                                @if (field.type === 'text') {
                                    <mat-form-field class="mt-4 w-100">
                                        <input matInput
                                               type="text"
                                               [placeholder]="'i18n_af_filterDialogField#Placeholder#' + field.name | translate "
                                               [formControl]="$any(form.controls)[field.name]"/>
                                    </mat-form-field>
                                }
                            </mat-expansion-panel>
                        }
                    }
                </div>
            </div>
            <div fxLayout="column" fxLayoutAlign="start stretch" class="pt-24">
                <ui-kit-button [label]="'i18n_af_buttonApply' | translate"
                               [disabled]="!isFormChanged"/>
                <ui-kit-button class="mt-16"
                               buttonType="button"
                               type="text"
                               (clickListener)="clearFilters()"
                               [disabled]="!hasFormValues"
                               [label]="'i18n_af_buttonClearAllFilters' | translate"/>
            </div>
        </form>
    }
</div>
